import TableMode from "./tableMode";

export default class ProjectInfo {
  public idProject: number = 0;
  public projectName: string = "";
  public projectCode: string = "";
  public year: string = "";
  public hasMilepostNavigation: boolean = false;
  public hasAllRoadsMBTiles: boolean = false;
  public hasThematicMaps: boolean = false;
  public hasSummaryCharts: boolean = false;
  public hasCharts: boolean = false;
  public chainageDisplayName: string = "";
  public chainageDisplayNameShort: string = "";
  public showChainageDefault: boolean = true;
  public showUnitsInTableColumnHeaders: boolean = false;
  public hasUturn: boolean = true;
  public hasDistress: boolean = false;
  public isPublished: boolean = true;
  public isExpired: boolean = false;
  public hasData: boolean = true;
  public hasMetricUnits: boolean = false;
  public autoProgressiveImageLoading: boolean = false;
  public imageDownloadLimit: number = -1;
  public tableMode: TableMode = TableMode.Auto;
  public isEsaSync: boolean = false;
  public esaCurrentMeasurementDate: Date | undefined = undefined;
}
